var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffinemapOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3629_1045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8562 3.11475C33.2026 3.11475 29.4562 6.86115 29.4562 11.5147C29.4562 16.1683 33.2026 19.9147 37.8562 19.9147C42.5098 19.9147 46.2562 16.1683 46.2562 11.5147C46.2562 6.86115 42.5098 3.11475 37.8562 3.11475ZM1.89753 3.11571C1.73659 3.11017 1.57617 3.13708 1.42585 3.19484C1.27552 3.2526 1.13836 3.34002 1.02253 3.45191C0.906708 3.56379 0.814587 3.69785 0.751659 3.84608C0.688731 3.99432 0.656284 4.15371 0.65625 4.31475L0.65625 38.0539C0.656288 38.2827 0.721686 38.5066 0.844739 38.6994C0.967792 38.8922 1.14338 39.0458 1.35081 39.1421L16.5505 46.2029C16.709 46.2766 16.8816 46.3148 17.0564 46.3148C17.2312 46.3148 17.4038 46.2766 17.5623 46.2029L32.2566 39.3773L46.9508 46.2029C47.7462 46.5725 48.6562 45.9917 48.6562 45.1147V11.5147C48.6574 13.9811 47.81 16.3727 46.2562 18.288V43.2341L32.9708 37.0627L32.8796 21.0931C32.375 20.8303 31.8919 20.528 31.4348 20.1893L31.5308 37.0671L17.7663 43.4621L17.5892 12.4512L27.7412 7.73475C28.2705 6.32909 29.0863 5.04887 30.1369 3.97539L17.0559 10.0522L2.36169 3.22659C2.21595 3.15892 2.05811 3.12122 1.89753 3.11571ZM48.6562 11.5147V11.3755C48.6563 11.3331 48.654 11.2906 48.6495 11.2483C48.6519 11.3371 48.6562 11.4255 48.6562 11.5147ZM43.8562 9.83475V13.1947H31.8562V9.83475H43.8562ZM3.05625 6.19539L16.1483 12.277L16.3263 43.453L3.05625 37.2869V6.19539Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 48.7148L48.595 0.776087",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3629_1045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.65625 0.714844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffinemapOff);
export default __webpack_public_path__ + "static/media/Offinemap-Off.147fb8acd8e49afbe3e9c846857f04d6.svg";
export { ForwardRef as ReactComponent };